import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-h5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "offset-1 col-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_client_loader = _resolveComponent("client-loader")!
  const _component_client_name = _resolveComponent("client-name")!
  const _component_accounts_list = _resolveComponent("accounts-list")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-px-md" }, {
    default: _withCtx(() => [
      _createVNode(_component_client_loader, {
        "client-id": _ctx.clientId,
        modelValue: _ctx.client,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event))
      }, null, 8, ["client-id", "modelValue"]),
      (_ctx.client)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, [
              _createVNode(_component_client_name, { client: _ctx.client }, null, 8, ["client"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_accounts_list, {
            "client-id": _ctx.clientId,
            platforms: _ctx.platforms,
            accounts: _ctx.accounts,
            "onUpdate:accounts": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accounts) = $event)),
            platform: _ctx.platform,
            "onUpdate:platform": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.platform) = $event)),
            "onUpdate:platforms": _ctx.setPlatforms
          }, null, 8, ["client-id", "platforms", "accounts", "platform", "onUpdate:platforms"])
        ])
      ])
    ]),
    _: 1
  }))
}